import { Injectable } from '@angular/core';

import { EnderecoApiService } from "./endereco-api.service";
import { UtilService } from "../../../shared/services/util.service";

declare var google: any;

@Injectable()
export class EnderecoService {

    constructor(
        private _enderecoApiService: EnderecoApiService,
        private _utilService: UtilService,
    ) { }

    onSubmit(object: any, onDone: any) {
        let cloneObject: any = this._utilService.cloneObject(object);

        if (cloneObject.cep) {
            cloneObject.cep = this._utilService.removeSpecialCharacter(cloneObject.cep);
        }

        if (cloneObject.cidade) {
            cloneObject.cidadeId = cloneObject.cidade.id;
        }

        if (cloneObject.tipoLogradouro) {
            cloneObject.tipoLogradouroId = cloneObject.tipoLogradouro.id;
        }

        delete cloneObject["cidade"];
        delete cloneObject["estado"];
        delete cloneObject["tipoLogradouro"];

        const onDone2: any = (function(response: any) {
            if (response) {
                cloneObject.coordenadaLatitude = response.lat;
                cloneObject.coordenadaLongitude = response.lng;
            }

            if (cloneObject.id) {
                this._enderecoApiService.onPut(cloneObject, onDone);
            } else {
                this._enderecoApiService.onPost(cloneObject, onDone);
            }
        }.bind(this));

        let y: any = this.getGeocodingAddress(object);
        this.getGeocoding(y, onDone2);
    }

    getAddress(object: any) {
        let address: any,
            street: string = "",
            typeStreet: string = "",
            number: string= "",
            city: string= "",
            neighborhood: string = "",
            complement: string = "",
            state: string = "",
            cep: string = "";

        if (object.tipoLogradouro) {
            typeStreet = object.tipoLogradouro.tipo;
        }

        if (object.logradouro) {
            street = " " + object.logradouro;
        }

        if (object.cidade) {
            city = " - " + object.cidade.nome;

            if (object.cidade.estado) {
                state =  " / " + object.cidade.estado.nome;
            }
        }

        if (object.bairro) {
            neighborhood = " - Bairro "+ object.bairro;
        }

        if (object.cep) {
            if(object.cep.length > 4) {
                cep = " - CEP: " + object.cep.slice(0, 5) + "-" + object.cep.slice(5, object.cep.length);
            } else {
                cep = " - CEP: " + object.cep;
            }
        }

        if (object.complemento) {
            complement = " " + object.complemento;
        }
        if (object.numero) {
            number = ", " + object.numero;
        } else {
            number = ", s/n";
        }

        if (street && number) {
            address = typeStreet + "" + street + "" + number + " " + complement + "" + neighborhood + "" + city + "" + state + "" + cep;
        }

        return address;
    }

    getGeocodingAddress(object: any) {
        let address: any,
            street: string = "",
            typeStreet: string = "",
            number: string= "",
            city: string= "",
            state: string = "",
            cep: string = "";

        if (object.logradouro) {
            street = object.logradouro;

            if (object.tipoLogradouro) {
                typeStreet = object.tipoLogradouro.tipo;
            }
        }

        if (object.cidade) {
            city = object.cidade.nome;
        }

        if (object.cidade.estado) {
            state =  object.cidade.estado.nome;
        }

        if (object.cep) {
            cep = object.cep;
        }

        if (object.numero) {
            number = object.numero;
        }

        address = cep + " " + street + " " + typeStreet + " " + city + " " + number + " " + state;

        return address;
    }

    getGeocoding(address: any, callback: any) {
        let geocoder: any = new google.maps.Geocoder();
        geocoder.geocode( { 'address': address}, function(results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                const lat: any = results[0].geometry.location.lat(),
                      lng: any = results[0].geometry.location.lng();

                let c: any = {lat: lat, lng: lng};

                this.initMap(lat, lng);

                callback(c);
            } else {
                this._utilService.swalMessageWarningCustom("Nenhuma coordenada encontrada para este endereço!");
                callback();
            }
        }.bind(this));
    }

    initMap(lat: any, lng: any) {
        let map: any;
        let latlng: any = new google.maps.LatLng(lat, lng);

        let mapOptions: any = {
            zoom: 16,
            center: latlng
        };
        map = new google.maps.Map(document.getElementById("map"), mapOptions);

        map.setCenter(latlng);
        let marker: any = new google.maps.Marker({
            position: latlng
        })
        marker.setMap(map);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/enderecos/shared/endereco.service.ts
 **/